export const language_dropdown_options = [
  // English Variants
  { id: "en-US", code: "en", title: "🇺🇸 English (US)", hint: "English" },
  { id: "en-GB", code: "en", title: "🇬🇧 English (UK)", hint: "English" },
  { id: "en-CA", code: "en", title: "🇨🇦 English (Canada)", hint: "English" },
  { id: "en-AU", code: "en", title: "🇦🇺 English (Australia)", hint: "English" },
  { id: "en-IN", code: "en", title: "🇮🇳 English (India)", hint: "English" },

  // Spanish Variants
  { id: "es-ES", code: "es", title: "🇪🇸 Español (España)", hint: "Spanish" },
  { id: "es-MX", code: "es", title: "🇲🇽 Español (México)", hint: "Spanish" },
  { id: "es-CO", code: "es", title: "🇨🇴 Español (Colombia)", hint: "Spanish" },
  { id: "es-AR", code: "es", title: "🇦🇷 Español (Argentina)", hint: "Spanish" },
  {
    id: "es-US",
    code: "es",
    title: "🇺🇸 Español (Estados Unidos)",
    hint: "Spanish",
  },

  // French Variants
  { id: "fr-FR", code: "fr", title: "🇫🇷 Français (France)", hint: "French" },
  { id: "fr-CA", code: "fr", title: "🇨🇦 Français (Canada)", hint: "French" },
  { id: "fr-BE", code: "fr", title: "🇧🇪 Français (Belgique)", hint: "French" },

  // German Variants
  {
    id: "de-DE",
    code: "de",
    title: "🇩🇪 Deutsch (Deutschland)",
    hint: "German",
  },
  { id: "de-AT", code: "de", title: "🇦🇹 Deutsch (Österreich)", hint: "German" },
  { id: "de-CH", code: "de", title: "🇨🇭 Deutsch (Schweiz)", hint: "German" },

  // Chinese Variants
  {
    id: "zh-Hans-CN",
    code: "zh-Hans-CN",
    title: "🇨🇳 简体中文 (中国大陆)",
    hint: "Chinese Simplified",
  },
  {
    id: "zh-Hant-TW",
    code: "zh-Hant-TW",
    title: "🇭🇰 繁體中文 (香港)",
    hint: "Chinese Traditional",
  },

  // Japanese
  { id: "ja-JP", code: "ja", title: "🇯🇵 日本語", hint: "Japanese" },

  // Korean
  { id: "ko-KR", code: "ko", title: "🇰🇷 한국어", hint: "Korean" },

  // Russian
  { id: "ru-RU", code: "ru", title: "🇷🇺 Русский", hint: "Russian" },

  // Arabic Variants
  { id: "ar-SA", code: "ar", title: "🇸🇦 العربية (السعودية)", hint: "Arabic" },
  { id: "ar-EG", code: "ar", title: "🇪🇬 العربية (مصر)", hint: "Arabic" },
  { id: "ar-MA", code: "ar", title: "🇲🇦 العربية (المغرب)", hint: "Arabic" },

  // Portuguese Variants
  {
    id: "pt-PT",
    code: "pt",
    title: "🇵🇹 Português (Portugal)",
    hint: "Portuguese",
  },
  {
    id: "pt-BR",
    code: "pt",
    title: "🇧🇷 Português (Brasil)",
    hint: "Portuguese",
  },

  // Italian
  { id: "it-IT", code: "it", title: "🇮🇹 Italiano", hint: "Italian" },

  // Dutch Variants
  {
    id: "nl-NL",
    code: "nl",
    title: "🇳🇱 Nederlands (Nederland)",
    hint: "Dutch",
  },
  { id: "nl-BE", code: "nl", title: "🇧🇪 Nederlands (België)", hint: "Dutch" },

  // Swedish
  { id: "sv-SE", code: "sv", title: "🇸🇪 Svenska", hint: "Swedish" },

  // Polish
  { id: "pl-PL", code: "pl", title: "🇵🇱 Polski", hint: "Polish" },

  // Turkish
  { id: "tr-TR", code: "tr", title: "🇹🇷 Türkçe", hint: "Turkish" },

  // Vietnamese
  { id: "vi-VN", code: "vi", title: "🇻🇳 Tiếng Việt", hint: "Vietnamese" },

  // Thai
  { id: "th-TH", code: "th", title: "🇹🇭 ไทย", hint: "Thai" },

  // Indonesian
  { id: "id-ID", code: "id", title: "🇮🇩 Bahasa Indonesia", hint: "Indonesian" },

  // Malay Variants
  {
    id: "ms-MY",
    code: "ms",
    title: "🇲🇾 Bahasa Melayu (Malaysia)",
    hint: "Malay",
  },
  {
    id: "ms-SG",
    code: "ms",
    title: "🇸🇬 Bahasa Melayu (Singapura)",
    hint: "Malay",
  },

  // Filipino
  {
    id: "fil-PH",
    code: "fil",
    title: "🇵🇭 Tagalog (Pilipinas)",
    hint: "Filipino",
  },

  // Hindi
  { id: "hi-IN", code: "hi", title: "🇮🇳 हिन्दी", hint: "Hindi" },

  // Bengali Variants
  { id: "bn-BD", code: "bn", title: "🇧🇩 বাংলা (বাংলাদেশ)", hint: "Bengali" },
  { id: "bn-IN", code: "bn", title: "🇮🇳 বাংলা (ভারত)", hint: "Bengali" },

  // Urdu Variants
  { id: "ur-PK", code: "ur", title: "🇵🇰 اردو (پاکستان)", hint: "Urdu" },
  { id: "ur-IN", code: "ur", title: "🇮🇳 اردو (بھارت)", hint: "Urdu" },

  // Persian Variants
  { id: "fa-IR", code: "fa", title: "🇮🇷 فارسی", hint: "Persian" },
  { id: "fa-AF", code: "fa", title: "🇦🇫 دری", hint: "Dari" },

  // Romanian
  { id: "ro-RO", code: "ro", title: "🇷🇴 Română", hint: "Romanian" },

  // Greek
  { id: "el-GR", code: "el", title: "🇬🇷 Ελληνικά", hint: "Greek" },

  // Czech
  { id: "cs-CZ", code: "cs", title: "🇨🇿 Čeština", hint: "Czech" },

  // Hungarian
  { id: "hu-HU", code: "hu", title: "🇭🇺 Magyar", hint: "Hungarian" },

  // Danish
  { id: "da-DK", code: "da", title: "🇩🇰 Dansk", hint: "Danish" },

  // Finnish
  { id: "fi-FI", code: "fi", title: "🇫🇮 Suomi", hint: "Finnish" },

  // Norwegian Variants
  // {
  //   id: "nb-NO",
  //   code: "nb",
  //   title: "🇳🇴 Norsk (Bokmål)",
  //   hint: "Norwegian Bokmål",
  // },
  // {
  //   id: "nn-NO",
  //   code: "nn",
  //   title: "🇳🇴 Norsk (Nynorsk)",
  //   hint: "Norwegian Nynorsk",
  // },

  // Ukrainian
  { id: "uk-UA", code: "uk", title: "🇺🇦 Українська", hint: "Ukrainian" },

  // Bulgarian
  { id: "bg-BG", code: "bg", title: "🇧🇬 Български", hint: "Bulgarian" },

  // Serbian
  { id: "sr-RS", code: "sr", title: "🇷🇸 Српски", hint: "Serbian" },

  // Croatian
  { id: "hr-HR", code: "hr", title: "🇭🇷 Hrvatski", hint: "Croatian" },

  // Slovak
  { id: "sk-SK", code: "sk", title: "🇸🇰 Slovenčina", hint: "Slovak" },

  // Lithuanian
  // { id: "lt-LT", code: "lt", title: "🇱🇹 Lietuvių", hint: "Lithuanian" },

  // Latvian
  // { id: "lv-LV", code: "lv", title: "🇱🇻 Latviešu", hint: "Latvian" },

  // Estonian
  // { id: "et-EE", code: "et", title: "🇪🇪 Eesti", hint: "Estonian" },

  // Slovenian
  // { id: "sl-SI", code: "sl", title: "🇸🇮 Slovenščina", hint: "Slovenian" },

  // Icelandic
  // { id: "is-IS", code: "is", title: "🇮🇸 Íslenska", hint: "Icelandic" },

  // Irish
  // { id: "ga-IE", code: "ga", title: "🇮🇪 Gaeilge", hint: "Irish" },

  // Welsh
  // { id: "cy-GB", code: "cy", title: "🏴󠁧󠁢󠁷󠁬󠁳󠁿 Cymraeg", hint: "Welsh" },

  // Hebrew
  // { id: "he-IL", code: "he", title: "🇮🇱 עברית", hint: "Hebrew" }, --- enable this!

  // Swahili Variants
  // { id: "sw-KE", code: "sw", title: "🇰🇪 Kiswahili (Kenya)", hint: "Swahili" }, --- enable this!
  // {
  //   id: "sw-TZ",
  //   code: "sw",
  //   title: "🇹🇿 Kiswahili (Tanzania)",
  //   hint: "Swahili",
  // },

  // Amharic
  // { id: "am-ET", code: "am", title: "🇪🇹 አማርኛ", hint: "Amharic" },

  // Yoruba
  // { id: "yo-NG", code: "yo", title: "🇳🇬 Yorùbá", hint: "Yoruba" },

  // Hausa
  // { id: "ha-NG", code: "ha", title: "🇳🇬 Hausa", hint: "Hausa" },

  // Oromo
  // { id: "om-ET", code: "om", title: "🇪🇹 Oromoo", hint: "Oromo" },

  // Zulu
  // { id: "zu-ZA", code: "zu", title: "🇿🇦 IsiZulu", hint: "Zulu" },

  // Afrikaans
  { id: "af-ZA", code: "af", title: "🇿🇦 Afrikaans", hint: "Afrikaans" },

  // Xhosa
  // { id: "xh-ZA", code: "xh", title: "🇿🇦 IsiXhosa", hint: "Xhosa" },

  // Catalan
  // { id: "ca-ES", code: "ca", title: "🇪🇸 Català", hint: "Catalan" },

  // Basque
  // { id: "eu-ES", code: "eu", title: "🇪🇸 Euskara", hint: "Basque" },

  // Galician
  // { id: "gl-ES", code: "gl", title: "🇪🇸 Galego", hint: "Galician" },

  // Maltese
  // { id: "mt-MT", code: "mt", title: "🇲🇹 Malti", hint: "Maltese" },

  // Tamil Variants
  { id: "ta-IN", code: "ta", title: "🇮🇳 தமிழ் (இந்தியா)", hint: "Tamil" },
  { id: "ta-LK", code: "ta", title: "🇱🇰 தமிழ் (இலங்கை)", hint: "Tamil" },
  { id: "ta-SG", code: "ta", title: "🇸🇬 தமிழ் (சிங்கப்பூர்)", hint: "Tamil" },

  // Telugu
  { id: "te-IN", code: "te", title: "🇮🇳 తెలుగు", hint: "Telugu" },

  // Marathi
  // { id: "mr-IN", code: "mr", title: "🇮🇳 मराठी", hint: "Marathi" },

  // Gujarati
  // { id: "gu-IN", code: "gu", title: "🇮🇳 ગુજરાતી", hint: "Gujarati" },

  // Kannada
  // { id: "kn-IN", code: "kn", title: "🇮🇳 ಕನ್ನಡ", hint: "Kannada" },

  // Malayalam
  // { id: "ml-IN", code: "ml", title: "🇮🇳 മലയാളം", hint: "Malayalam" },

  // Punjabi Variants
  { id: "pa-IN", code: "pa", title: "🇮🇳 ਪੰਜਾਬੀ (ਭਾਰਤ)", hint: "Punjabi" },
  { id: "pa-PK", code: "pa", title: "🇵🇰 ਪੰਜਾਬੀ (ਪਾਕਿਸਤਾਨ)", hint: "Punjabi" },

  // Burmese
  // { id: "my-MM", code: "my", title: "🇲🇲 မြန်မာဘာသာ", hint: "Burmese" },

  // Khmer
  { id: "km-KH", code: "km", title: "🇰🇭 ខ្មែរ", hint: "Khmer" },

  // Lao
  // { id: "lo-LA", code: "lo", title: "🇱🇦 ພາສາລາວ", hint: "Lao" },

  // Nepali
  // { id: "ne-NP", code: "ne", title: "🇳🇵 नेपाली", hint: "Nepali" },

  // Sinhala
  // { id: "si-LK", code: "si", title: "🇱🇰 සිංහල", hint: "Sinhala" },

  // Georgian
  // { id: "ka-GE", code: "ka", title: "🇬🇪 ქართული", hint: "Georgian" },

  // Armenian
  // { id: "hy-AM", code: "hy", title: "🇦🇲 Հայերեն", hint: "Armenian" },

  // Azerbaijani
  { id: "az-AZ", code: "az", title: "🇦🇿 Azərbaycan dili", hint: "Azerbaijani" },

  // Kazakh
  { id: "kk-KZ", code: "kk", title: "🇰🇿 Қазақ тілі", hint: "Kazakh" },

  // Uzbek
  { id: "uz-UZ", code: "uz", title: "🇺🇿 Oʻzbek tili", hint: "Uzbek" },

  // Mongolian
  // { id: "mn-MN", code: "mn", title: "🇲🇳 Монгол хэл", hint: "Mongolian" },

  // Bosnian
  // { id: "bs-BA", code: "bs", title: "🇧🇦 Bosanski", hint: "Bosnian" },

  // Macedonian
  // { id: "mk-MK", code: "mk", title: "🇲🇰 Македонски", hint: "Macedonian" },

  // Albanian
  // { id: "sq-AL", code: "sq", title: "🇦🇱 Shqip", hint: "Albanian" },

  // Ewe
  // { id: "ee-GH", code: "ee", title: "🇬🇭 Eʋegbe", hint: "Ewe" },

  // Twi
  // { id: "tw-GH", code: "tw", title: "🇬🇭 Twi", hint: "Twi" },

  // Igbo
  // { id: "ig-NG", code: "ig", title: "🇳🇬 Igbo", hint: "Igbo" },

  // Kinyarwanda
  { id: "rw-RW", code: "rw", title: "🇷🇼 Ikinyarwanda", hint: "Kinyarwanda" },

  // Malagasy
  // { id: "mg-MG", code: "mg", title: "🇲🇬 Malagasy", hint: "Malagasy" },

  // Maori
  // { id: "mi-NZ", code: "mi", title: "🇳🇿 Te Reo Māori", hint: "Maori" },

  // Samoan
  // { id: "sm-WS", code: "sm", title: "🇼🇸 Gagana Sāmoa", hint: "Samoan" },

  // Tongan
  // { id: "to-TO", code: "to", title: "🇹🇴 Lea Faka-Tonga", hint: "Tongan" },

  // Fijian
  // { id: "fj-FJ", code: "fj", title: "🇫🇯 Na Vosa Vakaviti", hint: "Fijian" },

  // Haitian Creole
  // {
  //   id: "ht-HT",
  //   code: "ht",
  //   title: "🇭🇹 Kreyòl Ayisyen",
  //   hint: "Haitian Creole",
  // },

  // Luxembourgish
  // {
  //   id: "lb-LU",
  //   code: "lb",
  //   title: "🇱🇺 Lëtzebuergesch",
  //   hint: "Luxembourgish",
  // },

  // Breton
  // { id: "br-FR", code: "br", title: "🇫🇷 Brezhoneg", hint: "Breton" },

  // Cornish
  // { id: "kw-GB", code: "kw", title: "🏴󠁧󠁢󠁷󠁬󠁳󠁿 Kernewek", hint: "Cornish" },

  // Scots Gaelic
  // { id: "gd-GB", code: "gd", title: "🏴󠁧󠁢󠁳󠁣󠁴󠁿 Gàidhlig", hint: "Scots Gaelic" },

  // Manx
  // { id: "gv-IM", code: "gv", title: "🇮🇲 Gaelg", hint: "Manx" },

  // --- Additional Languages for Broader Coverage ---

  // Akan
  // { id: "ak-GH", code: "ak", title: "🇬🇭 Akan", hint: "Akan" },

  // Fula Variants
  // { id: "ff-SN", code: "ff", title: "🇸🇳 Pulaar (Sénégal)", hint: "Fula" },
  // { id: "ff-NG", code: "ff", title: "🇳🇬 Fulfulde (Nijeriya)", hint: "Fula" },

  // Lingala
  // { id: "ln-CD", code: "ln", title: "🇨🇩 Lingála", hint: "Lingala" },

  // Luganda
  // { id: "lg-UG", code: "lg", title: "🇺🇬 Luganda", hint: "Luganda" },

  // Shona
  // { id: "sn-ZW", code: "sn", title: "🇿🇼 ChiShona", hint: "Shona" },

  // Sesotho
  // { id: "st-LS", code: "st", title: "🇱🇸 Sesotho", hint: "Sesotho" },

  // Setswana
  // { id: "tn-BW", code: "tn", title: "🇧🇼 Setswana", hint: "Setswana" },

  // Wolof
  // { id: "wo-SN", code: "wo", title: "🇸🇳 Wolof", hint: "Wolof" },

  // Tamazight
  // {
  //   id: "tzm-MA",
  //   code: "tzm",
  //   title: "🇲🇦 Tamazight (Central Atlas)",
  //   hint: "Tamazight",
  // },

  // Tigrinya Variants
  { id: "ti-ER", code: "ti", title: "🇪🇷 ትግርኛ (ኤርትራ)", hint: "Tigrinya" },
  { id: "ti-ET", code: "ti", title: "🇪🇹 ትግርኛ (ኢትዮጵያ)", hint: "Tigrinya" },

  // Assamese
  // { id: "as-IN", code: "as", title: "🇮🇳 অসমীয়া", hint: "Assamese" },

  // Odia
  // { id: "or-IN", code: "or", title: "🇮🇳 ଓଡ଼ିଆ", hint: "Odia" },

  // Kashmiri
  // { id: "ks-IN", code: "ks", title: "🇮🇳 कॉशुर", hint: "Kashmiri" },

  // Sindhi Variants
  // { id: "sd-PK", code: "sd", title: "🇵🇰 سنڌي (پاکستان)", hint: "Sindhi" },
  // { id: "sd-IN", code: "sd", title: "🇮🇳 سنڌي (ڀارت)", hint: "Sindhi" },

  // Dogri
  // { id: "doi-IN", code: "doi", title: "🇮🇳 डोगरी", hint: "Dogri" },

  // Maithili
  // { id: "mai-IN", code: "mai", title: "🇮🇳 मैथिली", hint: "Maithili" },

  // Santali
  // { id: "sat-IN", code: "sat", title: "🇮🇳 ᱥᱟᱱᱛᱟᱲᱤ", hint: "Santali" },

  // Konkani
  // { id: "kok-IN", code: "kok", title: "🇮🇳 कोंकणी", hint: "Konkani" },

  // Javanese
  // { id: "jv-ID", code: "jv", title: "🇮🇩 Basa Jawa", hint: "Javanese" },

  // Sundanese
  // { id: "su-ID", code: "su", title: "🇮🇩 Basa Sunda", hint: "Sundanese" },

  // Cebuano
  // { id: "ceb-PH", code: "ceb", title: "🇵🇭 Sinugboanon", hint: "Cebuano" },

  // Mon
  // { id: "mnw-MM", code: "mnw", title: "🇲🇲 မန်", hint: "Mon" },

  // Sango
  // { id: "sg-CF", code: "sg", title: "🇨🇫 Sängö", hint: "Sango" },

  // Uyghur
  // { id: "ug-CN", code: "ug", title: "🇨🇳 ئۇيغۇرچە", hint: "Uyghur" },

  // Tibetan
  // { id: "bo-CN", code: "bo", title: "🇨🇳 བོད་སྐད་", hint: "Tibetan" },

  // Kyrgyz
  // { id: "ky-KG", code: "ky", title: "🇰🇬 Кыргызча", hint: "Kyrgyz" },

  // Tajik
  // { id: "tg-TJ", code: "tg", title: "🇹🇯 Тоҷикӣ", hint: "Tajik" },

  // Turkmen
  // { id: "tk-TM", code: "tk", title: "🇹🇲 Türkmençe", hint: "Turkmen" },

  // Faroese
  // { id: "fo-FO", code: "fo", title: "🇫🇴 Føroyskt", hint: "Faroese" },

  // Sami Variants
  // {
  //   id: "se-NO",
  //   code: "se",
  //   title: "🇸🇪 Sámegiella (Nordsamisk, Norge)",
  //   hint: "Sami",
  // },
  // {
  //   id: "se-SE",
  //   code: "se",
  //   title: "🇸🇪 Sámegiella (Nordsamisk, Sverige)",
  //   hint: "Sami",
  // },

  // Walloon
  // { id: "wa-BE", code: "wa", title: "🇧🇪 Walon", hint: "Walloon" },

  // Western Frisian
  // { id: "fy-NL", code: "fy", title: "🇳🇱 Frysk", hint: "Western Frisian" },

  // Aymara Variants
  // { id: "ay-BO", code: "ay", title: "🇧🇴 Aymar aru (Bolivia)", hint: "Aymara" },
  // { id: "ay-PE", code: "ay", title: "🇵🇪 Aymar aru (Perú)", hint: "Aymara" },

  // Guarani
  // { id: "gn-PY", code: "gn", title: "🇵🇾 Avañe'ẽ", hint: "Guarani" },

  // Nahuatl
  // { id: "nah-MX", code: "nah", title: "🇲🇽 Nāhuatl", hint: "Nahuatl" },

  // Quechua Variants
  // { id: "qu-PE", code: "qu", title: "🇵🇪 Runasimi (Perú)", hint: "Quechua" },
  // { id: "qu-BO", code: "qu", title: "🇧🇴 Runasimi (Bolivia)", hint: "Quechua" },

  // Inuktitut
  // { id: "iu-CA", code: "iu", title: "🇨🇦 ᐃᓄᒃᑎᑐᑦ", hint: "Inuktitut" },

  // Papiamento Variants
  // {
  //   id: "pap-AW",
  //   code: "pap",
  //   title: "🇦🇼 Papiamentu (Aruba)",
  //   hint: "Papiamento",
  // },
  // {
  //   id: "pap-CW",
  //   code: "pap",
  //   title: "🇨🇼 Papiamentu (Curaçao)",
  //   hint: "Papiamento",
  // },

  // Hawaiian
  // { id: "haw-US", code: "haw", title: "🇺🇸 ʻŌlelo Hawaiʻi", hint: "Hawaiian" },

  // Tahitian
  // { id: "ty-PF", code: "ty", title: "🇵🇫 Reo Tahiti", hint: "Tahitian" },

  // Marshallese
  // { id: "mh-MH", code: "mh", title: "🇲🇭 Kajin M̧ajeļ", hint: "Marshallese" },
];
